import {
  GET_EVENTOS_START,
  GET_EVENTOS_SUCCESS,
  GET_EVENTOS_ERROR
} from '../actions'

const initialState = {
  loading: false,
  payload: [],
  error: null
}

const eventos = (state = initialState, { type, payload, error }) => {

  switch(type) {

    case GET_EVENTOS_START:
      return {
        ...state,
        loading: true,
        error
      }

    case GET_EVENTOS_SUCCESS:
      return {
        ...state,
        loading: false,
        payload
      }

    case GET_EVENTOS_ERROR:
      return {
        ...state,
        loading: false,
        error
      }

    default: return state
    
  }

}

export default eventos